module.exports = __webpack_public_path__ + "static/media/shapes-square.c4bbfe12.svg";